<template>
  <div ref="rightPanel" :class="{show:show}" class="rightPanel-container">
    <div class="rightPanel-background" />
    <div class="rightPanel">
      <div class="handle-button" :style="{'top':buttonTop+'px','background-color':theme}" @click="show=!show">
        <i :class="show?'el-icon-close':'el-icon-setting'" />
      </div>
      <div class="rightPanel-items">
        <div class="app-container">
          <span><h3>지도 옵션 설정</h3></span>
          <br>
          <el-collapse v-model="activeNames">

            <el-collapse-item title="투명도 설정" name="1">
                <el-slider v-model="mapOptionFillOpacity" :step="10" :min="0" :max="100" />
            </el-collapse-item>

            <el-collapse-item title="팝업 설정" name="2">
              <el-radio-group v-model="mapPopupViewType">
                <el-radio label="all">항상 보기</el-radio>
                <el-radio label="mouseover">마우스 오버 보기</el-radio>
              </el-radio-group>
            </el-collapse-item>

            <el-collapse-item title="색상 설정" name="3">
              <el-radio-group v-model="mapHeatColorType" >
                <el-radio label="default">기본색</el-radio>
                <el-radio label="red">빨강색</el-radio>
                <el-radio label="purple">보라색</el-radio>
              </el-radio-group>
            </el-collapse-item>

          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex'

const mapOptionStore = 'mapOptionStore'

export default {
  name: 'MapSetting',
  props: {
    clickNotClose: {
      default: false,
      type: Boolean
    },
    buttonTop: {
      default: 150,
      type: Number
    }
  },
  data() {
    return {
      show: false,
      activeNames: [],
      mapOptionFillOpacity: 20,
      mapPopupViewType: '',
      mapHeatColorType: ''
    }
  },
  computed: {
    theme() {
      return '#409EFF'
    },
    ...mapState(mapOptionStore, {
      mapStyle: state => state.mapStyle
    }),

    ...mapGetters(mapOptionStore, {
      getFillOpacity: 'getFillOpacity',
      getMapPopupViewType: 'getMapPopupViewType',
      getHeatMapColor: 'getHeatMapColor'
    })
  },
  watch: {
    mapOptionFillOpacity (value) {
      this.setLayerFillOpacity({ fillOpacity: (value / 100) })
    },
    mapPopupViewType (value) {
      this.setMapPopupViewType({ viewType: value })
    },
    mapHeatColorType (value) {
      this.setHeatMapColor({ heatColor: value })
    },
    show(value) {
      if (value && !this.clickNotClose) {
        this.addEventClick()
      }
      if (value) {
        this.addClass(document.body, 'showRightPanel')
      } else {
        this.removeClass(document.body, 'showRightPanel')
      }
    }
  },
  mounted() {
    this.insertToBody()
  },
  beforeDestroy() {
    const elx = this.$refs.rightPanel
    elx.remove()
  },
  created() {
    this.mapOptionFillOpacity = (this.getFillOpacity * 100)
    this.mapPopupViewType = this.getMapPopupViewType
    this.mapHeatColorType = this.getHeatMapColor
  },
  methods: {
    ...mapActions(mapOptionStore, {
      setLayerFillOpacity: 'setLayerFillOpacity',
      setMapPopupViewType: 'setMapPopupViewType',
      setHeatMapColor: 'setHeatMapColor'
    }),

    formatMapFillOpacityTooltip (val) {
      return val + ' %'
    },

    saveMapSetting () {
      this.$notify({
        title: 'Success',
        message: 'This is a success message',
        type: 'success'
      })
    },

    clearMapSetting () {
      this.$notify.error({
        title: 'Success',
        message: 'This is a success message',
      })
    },

    addEventClick() {
      window.addEventListener('click', this.closeSidebar)
    },
    closeSidebar(evt) {
      const parent = evt.target.closest('.rightPanel')
      if (!parent) {
        this.show = false
        window.removeEventListener('click', this.closeSidebar)
      }
    },
    insertToBody() {
      const elx = this.$refs.rightPanel
      const body = document.querySelector('body')
      body.insertBefore(elx, body.firstChild)
    },

    hasClass(ele, cls) {
      return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
    },

    addClass(ele, cls) {
      if (!this.hasClass(ele, cls)) ele.className += ' ' + cls
    },

    removeClass(ele, cls) {
      if (this.hasClass(ele, cls)) {
        const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
        ele.className = ele.className.replace(reg, ' ')
      }
    },
  }
}
</script>

<style>
.showRightPanel {
  overflow: hidden;
  position: relative;
  width: calc(100% - 15px);
}
</style>

<style lang="scss" scoped>
.rightPanel-background {
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity .3s cubic-bezier(.7, .3, .1, 1);
  background: rgba(0, 0, 0, .2);
  z-index: -1;
}

.rightPanel {
  width: 100%;
  max-width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, .05);
  transition: all .25s cubic-bezier(.7, .3, .1, 1);
  transform: translate(100%);
  background: #fff;
  z-index: 40000;
}

.show {
  transition: all .3s cubic-bezier(.7, .3, .1, 1);

  .rightPanel-background {
    z-index: 20000;
    opacity: 1;
    width: 100%;
    height: 100%;
  }

  .rightPanel {
    transform: translate(0);
  }
}

.handle-button {
  width: 48px;
  height: 48px;
  position: absolute;
  left: -48px;
  text-align: center;
  font-size: 24px;
  border-radius: 6px 0 0 6px !important;
  z-index: 0;
  pointer-events: auto;
  cursor: pointer;
  color: #fff;
  line-height: 48px;
  i {
    font-size: 24px;
    line-height: 48px;
  }
}
</style>
